export class CashBalanceTypes {
  public static Cash: string = 'Cash (Including UAC)';
  public static Float: string = 'Float';
  public static VATLiability: string = 'VAT Liability';
  public static Debtors: string = 'Debtors';
  public static Creditors: string = 'Creditors (Gross)';

  public static AllTypes: string[] = [
    CashBalanceTypes.Cash,
    CashBalanceTypes.Float,
    CashBalanceTypes.VATLiability,
    CashBalanceTypes.Debtors,
    CashBalanceTypes.Creditors
  ];
}
